/**
 * Disable the continue button when checkbox is unchecked
 */
export default function initCheckboxConfirmation() {
    const confirmationCheckbox = document.getElementById('wizard_shared_capture_enquiry_information_confirm_checkbox');
    if (!confirmationCheckbox) {
        return;
    }

    const continueButtonPosition = document.getElementsByClassName('govuk-button').length - 1;
    const continueButton = document.getElementsByClassName('govuk-button')[continueButtonPosition];

    let checkboxChecked = false;
    continueButton.disabled = true;

    function EnableDisableContinueButton() {
        continueButton.disabled = checkboxChecked !== true;
    }

    confirmationCheckbox.addEventListener('change', () => {
        if (confirmationCheckbox.checked === true) {
            checkboxChecked = true;
            EnableDisableContinueButton();
        } else {
            checkboxChecked = false;
            EnableDisableContinueButton();
        }
    });
}
